var map = {
	"./chocolate-fictional/supply_chain_origin.json": [
		6171,
		[
			6171
		]
	],
	"./chocolate/supply_chain_origin.json": [
		4575,
		[
			4575
		]
	],
	"./hemas-clogard/supply_chain_origin.json": [
		6584,
		[
			6584
		]
	],
	"./linqOne/supply_chain_origin.json": [
		4479,
		[
			4479
		]
	],
	"./munchee-tikiri-marie/supply_chain_origin.json": [
		6264,
		[
			6264
		]
	],
	"./shan-teas/supply_chain_origin.json": [
		8329,
		[
			8329
		]
	],
	"./wipotech-chocolates/supply_chain_origin.json": [
		6446,
		[
			6446
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6688;
module.exports = webpackAsyncContext;